import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { DrawerMode, DrawerPosition } from '@shared-features/enums/layout.enum';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DrawerComponent implements OnInit {
  @Input() position = DrawerPosition.Start;
  @Input() mode = DrawerMode.Side;
  @Input() hasBackdrop = true;
  @Input() drawerOpened = true;
  @Input() showCloseButton = false;
  @Input() openDrawerWidth = 0;
  @Input() applyMainPageHeight = false;
  @Output() drawerClosed = new EventEmitter();
  @ViewChild('drawer', { static: true }) drawer: MatDrawer;

  public DrawerPosition = DrawerPosition;

  constructor() { }

  ngOnInit() {

  }

  // UI Events
  onCloseButtonClicked() {
    this.drawerClosed.emit();
  }

  toggleDrawer() {
    this.drawer.toggle();
  }
}
